var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-treeselect"},[_c('treeselect',{attrs:{"multiple":true,"options":_vm.items,"value-consists-of":"LEAF_PRIORITY","disabled":_vm.disabled,"placeholder":_vm.localStorage.translations.pages.sales_project['planned_resources-time_period-inputs'][
        'ne-vybrano'
      ],"maxHeight":130,"rules":_vm.rules},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }